export const getMainnetURI = (): string => {
    return "https://bsc-dataseed1.binance.org";
};
